<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-bnxt1" id="calibre_pb_19"> </p>
<p class="quote-red"> </p>
<p class="quote-red">FlavCity changed the way I read labels! I dreaded reading labels before. I never paid attention to the added sugars, natural flavors, or types of oils, and didn’t understand what expeller pressed meant! Thanks to FlavCity, reading labels is much easier now and takes less time.</p>
<p class="quote-a-red">—Mariam A.</p>
<div class="calibre1" id="calibre_pb_20"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_010.vue?75b0e28b